<div class="flex flex-col flex-auto min-w-0">
  <!-- Header Section -->
  <div class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-transparent">
      <div class="flex-1 min-w-0">
          <div class="flex items-center mb-2">
              <a class="inline-flex items-center text-secondary font-medium" [routerLink]="'/community-list'">
                  <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
                  <span class="ml-1">Back</span>
              </a>
          </div>
          <div class="mt-2">
              <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                  Create Community
              </h2>
          </div>
      </div>
  </div>

  <!-- Form Section -->
  <div class="flex-auto p-6 sm:p-10">
      <div class="">
          <form class="p-4 bg-card shadow rounded overflow-hidden" [formGroup]="communityForm" #communityFormNgForm="ngForm" (ngSubmit)="onSubmit()">
              <div class="flex flex-col gt-xs:flex-row">
                  <!-- First Column -->
                  <div class="mainDiv">
                      <mat-form-field class="flex-auto gt-xs:pr-3 items">
                          <mat-label>Community Name</mat-label>
                          <input placeholder="Enter community name" matInput [formControlName]="'name'" required>
                          <mat-error *ngIf="communityForm.get('name').hasError('required')">Please enter community name</mat-error>
                          <mat-error *ngIf="communityForm.get('name').hasError('maxlength')">Maximum 50 characters allowed</mat-error>
                      </mat-form-field>

                      <mat-form-field class="flex-auto gt-xs:pr-3 items">
                          <mat-label>Location</mat-label>
                          <input placeholder="Enter location" matInput [formControlName]="'location'" required>
                          <mat-icon matSuffix>location_on</mat-icon>
                          <mat-error *ngIf="communityForm.get('location').hasError('required')">Please enter location</mat-error>
                      </mat-form-field>
                  </div>

                  <!-- Second Column -->
                  <div class="mainDiv">
                      <mat-form-field class="flex-auto gt-xs:pr-3 items">
                          <mat-label>Contact Phone</mat-label>
                          <input placeholder="Enter contact phone" matInput [formControlName]="'contactPhone'">
                          <mat-error *ngIf="communityForm.get('contactPhone').hasError('pattern')">Please enter a valid phone number</mat-error>
                      </mat-form-field>
                  </div>
              </div>

              <!-- Full Width Description Field -->
              <div class="w-full mt-4">
                  <mat-form-field class="w-full">
                      <mat-label>Description</mat-label>
                      <textarea matInput [formControlName]="'description'" placeholder="Enter community description" rows="3"></textarea>
                      <mat-hint>Brief description about the community</mat-hint>
                      <mat-error *ngIf="communityForm.get('description').hasError('maxlength')">Maximum 200 characters allowed</mat-error>
                  </mat-form-field>
              </div>

              <!-- Form Actions -->
              <div class="flex justify-end gap-4 mt-8">
                  <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
                  <button mat-raised-button color="primary" type="submit" [disabled]="communityForm.invalid || isLoading">
                      <span *ngIf="!isLoading">Create Community</span>
                      <span *ngIf="isLoading" class="flex items-center">
                          <mat-icon class="animate-spin">refresh</mat-icon>
                          <span class="ml-2">Creating...</span>
                      </span>
                  </button>
              </div>
          </form>
      </div>
  </div>

  <!-- Loader -->
  <div class="loaderMain" *ngIf="pageLoader === true">
      <div>
          <img src="assets\TrailFusion\Trail-Fusion-logo.jpg" class="LoaderImage">
          <p class="loaderText">{{pageLoaderText}}</p>
      </div>
  </div>
</div>